import AIRadar from "../components/modules/AIRadar";
import AILeaderboard from "../components/modules/AILeaderboard";
import AIConsensus from "../components/modules/AIConsensus";
import AIMarketMap from "../components/modules/AIMarketMap";
import OpportunityEngine from "../components/modules/OpportunityEngine";
import AIAnalyst from "../components/modules/AIAnalyst";
import AIVisibilityBreakdown from "../components/modules/AIVisibilityBreakdown";


export const moduleRegistry = {
  visibilityBreakdown: {
    component: AIVisibilityBreakdown,
    table: "ai_analyst_view"
  },

  radar: {
  component: AIRadar,
  table: "toren_competitive_radar_role_v1"
},

  marketMap: {
  component: AIMarketMap,
  table: "toren_competitive_perception_role_v1"
},

  leaderboard: {
  component: AILeaderboard,
  table: "toren_competitive_share_of_voice_recent_role_v1"
},

  aiConsensus: {
    component: AIConsensus,
    table: "prompt_results"
  },

  opportunityEngine: {
  component: OpportunityEngine,
  table: "toren_competitive_opportunities_role_v1",
  orderBy: "total_gap_count",
  limit: 5
},

  analyst: {
    component: AIAnalyst,
    table: "ai_analyst_view"
  }
};